import Vue from "Vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { Notification, TypeNotification } from "../../../models/notification";
import $ from "jquery";

@Component
export default class NotificationItem extends Vue {
	@Prop()
	public notification!: Notification;

	@Prop({ default: true })
	public canClose;

	@Prop({ default: false })
	public stopTimer;

	@Prop({ default: false })
	public autoHide;

	@Prop({ default: false })
	public progressBar;

	private divElement;

	public getType(): number {
		return this.notification.type;
	}

	private timer;
	private startTime = Date.now();
	private currentTime;
	private idSetInterval;
	private tempInterval;
	private delay;

	public mounted(): void {
		this.delay = this.notification.numberSecondsDisplay;
		this.currentTime = this.delay;

		this.divElement = <HTMLDivElement> this.$refs.notification;
		if (this.autoHide) {
			this.startTimer(this.delay);
		}

		if (this.progressBar) {
			const bgTime = <HTMLDivElement> this.$refs.bgTime;
			$(bgTime).width("100%");
			this.idSetInterval = setInterval(this.updateProgressBar, 50);
		}

		this.tempInterval = this.getTimeLeft() * 100 / 30000;
	}

	private getTypeIcon(): string {
		let typeIcon = "fa-circle-info";

		switch (this.notification.type) {
			case TypeNotification.Warning:
				typeIcon = "fa-circle-exclamation";
				break;
			case TypeNotification.Success:
				typeIcon = "fa-circle-check";
				break;
			case TypeNotification.Failed:
				typeIcon = "fa-circle-xmark";
				break;
		}

		return typeIcon;
	}

	private getTypeTitle(): string {
		let typeTitle = "Information";

		switch (this.notification.type) {
			case TypeNotification.Warning:
				typeTitle = "Attention";
				break;
			case TypeNotification.Success:
				typeTitle = "Succès";
				break;
			case TypeNotification.Failed:
				typeTitle = "Erreur";
				break;
		}

		return typeTitle;
	}

	public ifTypeIsFailed(): boolean {
		return this.notification.type === TypeNotification.Failed;
	}

	public ifTypeIsSuccess(): boolean {
		return this.notification.type === TypeNotification.Success;
	}

	public ifTypeIsWarning(): boolean {
		return this.notification.type === TypeNotification.Warning;
	}

	public ifTypeIsInformation(): boolean {
		return this.notification.type === TypeNotification.Information;
	}

	private getTimeLeft(): any {
		return this.currentTime - (Date.now() - this.startTime);
	}

	@Watch("stopTimer")
	public listenStopTimer(): void {
		if (this.autoHide) {
			if (this.stopTimer) {
				clearInterval(this.timer);
				this.currentTime = this.getTimeLeft();
			} else {
				this.startTime = Date.now();
				this.startTimer(this.currentTime);
			}
		}
	}

	private startTimer(millis: number): void {
		this.timer = setTimeout(() => this.close(), millis);
	}

	public close(): void {
		$(this.divElement).fadeOut(200, () => {
			clearInterval(this.idSetInterval);
			this.$emit("delete", this.notification.id);
		});
	}

	private updateProgressBar(): void {
		const bgTime = <HTMLDivElement> this.$refs.bgTime;
		let resultWidth = this.getTimeLeft() * 100 / this.delay;

		if (this.stopTimer) {
			resultWidth = this.tempInterval;
		} else {
			this.tempInterval = resultWidth;
		}

		$(bgTime).width(resultWidth + "%");
	}
}



// WEBPACK FOOTER //
// ./src/shared/components/notification/notification-item/notification-item.ts